import { IContentResource, IContentResourceVersion } from '../services/api';
import { escapeHtml } from './escapeHtml';

interface IEditorResource {
  content: string;
  type: 'media' | 'iframe' | 'picture';
  subtype: string;
}

export const getLatestResourceVersion = (
  resource: IContentResource,
): IContentResourceVersion | undefined => resource.versions[0];

const toEditorResource = (
  resource: IContentResource,
  version: IContentResourceVersion,
): IEditorResource => {
  if (resource.type === 'video' || resource.type === 'podcast') {
    return {
      content: version.payload.url,
      type: 'media',
      subtype: resource.type === 'video' ? 'videoaula' : 'podcast',
    };
  }

  if (resource.type === 'infographic') {
    return {
      content: encodeURI(
        JSON.stringify({
          url: version.payload.url,
          width: version.payload.width || '100%',
          height: version.payload.height || '650px',
          type: 'iframe',
        }),
      ),
      type: 'iframe',
      subtype: 'infographic',
    };
  }

  return {
    content: JSON.stringify({
      name: version.payload.caption || resource.title,
      resource: version.payload.source || '',
      descripiton: version.payload.alternativeText || '',
      url: version.payload.url,
      type: 'picture',
    }),
    type: 'picture',
    subtype: '',
  };
};

export const buildEditorResourceHtml = (
  resource: IContentResource,
): string | undefined => {
  const version = getLatestResourceVersion(resource);
  if (!version) {
    return undefined;
  }

  const editorResource = toEditorResource(resource, version);
  return `<div class="resource" data-interaction="true" data-type="${
    editorResource.type
  }" data-subtype="${editorResource.subtype}" data-resource="${escapeHtml(
    editorResource.content,
  )}" data-resource-id="${resource.id}" data-resource-version-id="${
    version.id
  }">${escapeHtml(resource.title)}</div>\n<p>&nbsp;</p>`;
};
